const CLIENT_MESSAGES_STORE = "ClientMessages";
import dataStore from "@/services/api/store";
import channelManagement from "./channelManagement";
import { Subject } from "rxjs";

class MessageRoom {
  constructor(roomId) {
    this.roomId = roomId;
    this.messages = [];
    this.channel = channelManagement.getChannel(roomId);
    this.messagesSub = new Subject();
    this.channel.messages.subscribe(msg => {
      this.messages.push(msg);
      this.messagesSub.next(msg);
    });
  }

  sendMessage(message) {
    this.channel.push(message);
  }

  init() {
    if (this.messages.length === 0) {
      return this.loadMoreMessages();
    }
    return new Promise(resolve => resolve(this.messages));
  }

  loadMoreMessages() {
    if (this.finished || this.loading) {
      return new Promise(resolve => resolve([]));
    }
    this.loading = true;
    const oldestSeen = this.messages[0];
    const last_seen_timestamp = oldestSeen && oldestSeen.created_at;

    return dataStore
      .findAll(
        CLIENT_MESSAGES_STORE,
        {
          limit: 40,
          room: this.roomId,
          last_seen_timestamp
        },
        { force: true }
      )
      .then(messages => {
        if (messages.length === 0) {
          this.finished = true;
          return messages;
        }

        const olderMessages = messages.reverse();
        this.messages = olderMessages.concat(this.messages);
        this.loading = false;
        return olderMessages;
      });
  }
}

class Rooms {
  constructor() {
    this.rooms = {};
  }
  getRoom(roomId) {
    if (!this.rooms[roomId]) {
      const room = new MessageRoom(roomId);
      this.rooms[roomId] = room;
    }
    return this.rooms[roomId];
  }
}

export default new Rooms();
